export default __webpack_public_path__ + "static/media/wow_girl.be3f9a5b.png";